
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toArabicNumbers } from "@/utils/arabicNumbers";
import { School, Activity, Users, XCircle } from "lucide-react";

interface School {
  id: string;
  subscription_id: string;
  school_name: string;
  email: string;
  phone?: string;
  status: 'active' | 'inactive' | 'expired';
  subscription_end?: string;
  students_count: number;
  created_at: string;
  updated_at: string;
}

interface SchoolStatsCardsProps {
  schools: School[];
}

const SchoolStatsCards = ({ schools }: SchoolStatsCardsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      <Card className="bg-white/70 backdrop-blur-sm border-white/20 border-l-4 border-l-blue-600">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="bg-blue-100 p-2 rounded-lg">
                <School className="h-5 w-5 text-blue-600" />
              </div>
              <span className="text-sm text-gray-600">إجمالي المدارس</span>
            </div>
            <span className="text-2xl font-bold text-blue-600">{toArabicNumbers(schools.length)}</span>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-white/70 backdrop-blur-sm border-white/20 border-l-4 border-l-green-600">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="bg-green-100 p-2 rounded-lg">
                <Activity className="h-5 w-5 text-green-600" />
              </div>
              <span className="text-sm text-gray-600">المدارس النشطة</span>
            </div>
            <span className="text-2xl font-bold text-green-600">
              {toArabicNumbers(schools.filter(s => s.status === "active").length)}
            </span>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-white/70 backdrop-blur-sm border-white/20 border-l-4 border-l-purple-600">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="bg-purple-100 p-2 rounded-lg">
                <Users className="h-5 w-5 text-purple-600" />
              </div>
              <span className="text-sm text-gray-600">إجمالي الطلاب</span>
            </div>
            <span className="text-2xl font-bold text-purple-600">
              {toArabicNumbers(schools.reduce((total, school) => total + (school.students_count || 0), 0))}
            </span>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-white/70 backdrop-blur-sm border-white/20 border-l-4 border-l-red-600">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="bg-red-100 p-2 rounded-lg">
                <XCircle className="h-5 w-5 text-red-600" />
              </div>
              <span className="text-sm text-gray-600">اشتراكات منتهية</span>
            </div>
            <span className="text-2xl font-bold text-red-600">
              {toArabicNumbers(schools.filter(s => s.status === "expired").length)}
            </span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SchoolStatsCards;
